import { render, staticRenderFns } from "./Datasets.vue?vue&type=template&id=65a7dc9d&scoped=true"
import script from "./Datasets.vue?vue&type=script&lang=js"
export * from "./Datasets.vue?vue&type=script&lang=js"
import style0 from "./Datasets.vue?vue&type=style&index=0&id=65a7dc9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a7dc9d",
  null
  
)

export default component.exports